<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="contents">
<div class="header">
<h3>Table of Contents</h3>
</div>
<h4 class="sigil_not_in_toc"><a href="#/Text/Section0004">The Translator’s Foreword.</a></h4>
<h4 class="sigil_not_in_toc"><a href="#/Text/Section0005">The Book of The Thousand Nights and a Night</a></h4>
<ol>
<li>
<ul>
<li><a href="#/Text/Section0005">The Tale of the Hashish Eater.</a></li>
<li><a href="#/Text/Section0006">The Tale of Hammad the Badawi.</a></li>
</ul>
</li>
<li><a href="#/Text/Section0007">The Birds and Beasts and The Carpenter</a></li>
<li><span href="#/Text/Section0008" title="Link target outside of Sample">The Hermits.</span></li>
<li><span href="#/Text/Section0009" title="Link target outside of Sample">Tale of the Water Fowl and The Tortoise.</span></li>
<li>
<span href="#/Text/Section0010" title="Link target outside of Sample">Tale of the Wolf and the Fox.</span>
<ul>
<li><span href="#/Text/Section0011" title="Link target outside of Sample">The Tale of the Falcon and the Partridge.</span></li>
</ul>
</li>
<li><span href="#/Text/Section0012" title="Link target outside of Sample">Tale of the Mouse and the Ichneumon</span></li>
<li><span href="#/Text/Section0013" title="Link target outside of Sample">The Cat and the Crow</span></li>
<li>
<span href="#/Text/Section0014" title="Link target outside of Sample">The Fox and the Crow</span>
<ul>
<li><span href="#/Text/Section0015" title="Link target outside of Sample">The Flea and the Mouse</span></li>
<li><span href="#/Text/Section0016" title="Link target outside of Sample">The Saker and the Birds.</span></li>
<li><span href="#/Text/Section0017" title="Link target outside of Sample">The Sparrow and the Eagle</span></li>
</ul>
</li>
<li>
<span href="#/Text/Section0018" title="Link target outside of Sample">The Hedgehog and the Wood-Pigeons</span>
<ul>
<li><span href="#/Text/Section0019" title="Link target outside of Sample">The Merchant and the Two Sharpers</span></li>
</ul>
</li>
<li>
<span href="#/Text/Section0020" title="Link target outside of Sample">The Thief and his Monkey</span>
<ul>
<li><span href="#/Text/Section0021" title="Link target outside of Sample">The Foolish Weaver</span></li>
</ul>
</li>
<li><span href="#/Text/Section0022" title="Link target outside of Sample">The Sparrow and the Peacock</span></li>
<li><span href="#/Text/Section0023" title="Link target outside of Sample">Tale of Ali Bin Bakkar and of Shams Al-Nahar.</span></li>
<li><span href="#/Text/Section0024" title="Link target outside of Sample">Tale of Kamar Al Zaman</span><br/></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?addcde42